// This code is used in the mobile api so we need to extract it to pure function.
import type { BuilderUiStore } from '~/stores/builder.ui.store';
import type { ToastStore } from '~/stores/toast.store';
import { getFixedT } from 'i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import { TOAST_IDS } from '~/common/flows.constants';
import { ToastType } from '@honeybook/hbui/dist/components/HBToast/HBToast.types';
import { ServiceSelectionItemBlock } from '~/models/blocks/service-selection-item-block.model';
import { FlowRouteType } from '~/utils/flow.utils';

// Extracted this function to it's own file to prevent circular deps.
export const showFlowErrorsToast = ({
    builderUiStore,
    toastStore,
    goToEditMode
}: {
    builderUiStore: BuilderUiStore;
    toastStore: ToastStore;
    goToEditMode?: () => void;
}) => {
    const { selectedFlow, setShowErrors, selectAndScrollToBlock } =
        builderUiStore;

    const builderT = getFixedT(null, NAMESPACES.BUILDER);
    setShowErrors(true);
    if (!selectedFlow.hasErrors) {
        setShowErrors(false);

        return;
    }

    const { blocksWithErrors } = selectedFlow;
    if (!toastStore.byId(TOAST_IDS.ERRORS_BUILDER)) {
        toastStore.add({
            type: ToastType.Error,
            id: TOAST_IDS.ERRORS_BUILDER,
            text: builderT('errors.share_file'),
            autoDismissMs: 12000,
            actionLink: {
                text: `ISSUE${blocksWithErrors.length > 1 ? 'S' : ''} TO FIX: ${
                    blocksWithErrors.length
                } `,
                onClick: () => {
                    if (
                        window.location.pathname.includes(
                            FlowRouteType.preview
                        ) &&
                        goToEditMode
                    ) {
                        goToEditMode();
                        return;
                    }

                    const firstBlockWithError = blocksWithErrors[0];
                    let overridePageId;
                    if (
                        firstBlockWithError instanceof
                            ServiceSelectionItemBlock &&
                        firstBlockWithError.isMissingTitleOnInvoiceInstance
                    ) {
                        overridePageId = selectedFlow.pageWithInvoice?.page_id;
                    }

                    selectAndScrollToBlock({
                        block: firstBlockWithError,
                        focusBlock: false,
                        overridePageId
                    });

                    toastStore.remove(TOAST_IDS.ERRORS_BUILDER);
                },
                align: 'right'
            }
        });
    }
};
